import React from 'react';
import LegalPage from '../components/LegalPage';
import { privacySections } from '../data/legalContent';

export default function Privacy() {
  return (
    <LegalPage
      eyebrow="Privacy"
      title="Privacy Policy"
      updated="March 23, 2026"
      introduction="Your privacy matters to us. This policy describes what information Paddle Up collects, why we collect it, how we use it, who we share it with, and your choices."
      sections={privacySections}
      relatedLabel="Terms of Service"
      relatedPath="/terms"
    />
  );
}